import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { statusDefaultTextValue } from '@shared/constants/status-default-text-value';
import { TextValue } from '@shared/interfaces';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { OverlayPanelModule } from 'primeng/overlaypanel';

@Component({
    selector: 'app-status-filters-multi-select',
    standalone: true,
    imports: [TranslateModule, ButtonModule, OverlayPanelModule, CheckboxModule, FormsModule, NgClass],
    templateUrl: './status-filters-multi-select.component.html',
    styleUrls: ['./status-filters-multi-select.component.scss'],
})
export class StatusFiltersMultiSelectComponent implements OnChanges {
    @Input({ required: true }) statusesToDisplay: TextValue[] = [];
    @Input({ required: true }) selectedStatuses: number[] | number = [];
    @Input() id: string = 'status-filters';
    @Output() statusesChanged: EventEmitter<number[]> = new EventEmitter<number[]>();

    selectedStatusTextValue: TextValue = statusDefaultTextValue;
    selectedStatusesArr: number[] = [statusDefaultTextValue.value];
    statusTextDisplay: string = '';

    onStatusSelect(option: number) {
        if (option === statusDefaultTextValue.value) this.selectedStatusesArr = [statusDefaultTextValue.value];
        if (this.selectedStatusesArr.includes(statusDefaultTextValue.value)) this.selectedStatusesArr = [];
        this.selectedStatusesArr.includes(option)
            ? (this.selectedStatusesArr = this.selectedStatusesArr.filter(status => status !== option))
            : this.selectedStatusesArr.push(option);
        if (!this.selectedStatusesArr.length) this.selectedStatusesArr = [statusDefaultTextValue.value];
        if (
            this.selectedStatusesArr.length === this.statusesToDisplay.length - 1 &&
            !this.selectedStatusesArr.find(status => status === statusDefaultTextValue.value)
        )
            this.selectedStatusesArr = [statusDefaultTextValue.value];
        this.statusesChanged.emit(this.selectedStatusesArr);
    }

    ngOnChanges(): void {
        if (Array.isArray(this.selectedStatuses)) this.selectedStatusesArr = this.selectedStatuses;
        this.getStatusText();
    }

    private getStatusText(): void {
        if (Array.isArray(this.selectedStatuses))
            this.statusTextDisplay =
                this.selectedStatuses.length >= 2
                    ? 'status.filters.statuses.label'
                    : this.selectedStatuses.length === 1 && this.selectedStatuses[0] !== statusDefaultTextValue.value
                      ? this.getSingleStatusText(this.selectedStatuses[0])
                      : this.resetToDefaultStatus();
    }

    private getSingleStatusText(statusValue: number): string {
        const status = this.statusesToDisplay.find(status => status.value === statusValue);
        return status ? status.text : statusDefaultTextValue.text;
    }

    private resetToDefaultStatus(): string {
        this.selectedStatuses = [statusDefaultTextValue.value];
        this.selectedStatusesArr = [statusDefaultTextValue.value];
        return statusDefaultTextValue.text;
    }
}
